import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger'

/**
 * DTO for competency list item response
 */
export class CompetencyDto {
  @ApiProperty({
    description: 'Competency UUID',
    example: '123e4567-e89b-12d3-a456-426614174000',
  })
  id: string

  @ApiPropertyOptional({
    description: 'Competency code',
    example: 'MATH-C1',
  })
  code?: string

  @ApiProperty({
    description: 'Competency statement (action verb)',
    example: 'Calculer avec des nombres décimaux',
  })
  statement: string

  @ApiPropertyOptional({
    description: 'Domain or category',
    example: 'Calculer',
  })
  domain?: string

  @ApiProperty({
    description: 'URL-friendly slug',
    example: 'calculer-avec-des-nombres-decimaux',
  })
  slug: string

@ApiProperty({
  description: 'Subject ID',
  example: '123e4567-e89b-12d3-a456-426614174000',
})
  subjectId: string

  @ApiPropertyOptional({
    description: 'Associated subject',
    type: 'object',
    additionalProperties: true,
  })
  subject?: {
    id: string
    code: string
    label: string
    slug: string
  }

  @ApiPropertyOptional({
    description: 'Count of related entities',
    type: 'object',
    additionalProperties: true,
  })
  _count?: {
    programLinks: number
  }

  @ApiPropertyOptional({
    description: 'Whether the competency is archived',
    example: false,
  })
  isArchived?: boolean

  @ApiProperty({
    description: 'Creation timestamp',
    example: '2024-01-01T00:00:00.000Z',
  })
  createdAt: Date

  @ApiProperty({
    description: 'Last update timestamp',
    example: '2024-01-01T00:00:00.000Z',
  })
  updatedAt: Date

  @ApiPropertyOptional({
    description: 'Soft deletion timestamp',
    example: null,
  })
  deletedAt?: Date | null
}